import React, { Component } from "react";
import Button from '@material-ui/core/Button';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FormControl, InputLabel, Select, OutlinedInput, MenuItem } from "@material-ui/core";
import { WarehouseService } from "../Services/WarehouseService";
import { format_date_only } from "../Utils";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
        flexGrow: 1,
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(1),
        width: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
  });

class InventoryReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        salesStartDate: moment(),
        salesEndDate: moment(),
        master_source: [],
        selected_source: "b024413e-1651-4ce5-a4ce-84cc53434a16",
        selected_farm: "5c72f99a-09a8-49b6-bd60-1d3b4606dc42",
        selected_farm_return: "9dde52ed-23e7-464c-8601-ed2a0b107e95"
      }

      props.setTitle('Inventory Reports');
    }

    componentDidMount(){
        this.fetchSourcesFilter();
    }

    fetchSourcesFilter = () => {
        WarehouseService.getWarehouseList(0, 999, "", "name", "asc")
        .then((data) => {
            console.log(data);
            let source_names = [];
            let master_source = [];
            if(data && data.warehouse.length > 0){
                source_names = source_names.concat(data.warehouse.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                )));
                master_source = master_source.concat(data.warehouse);
            }
            this.setState({master_source, source_names});  
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    handleSourceSelection = (e) => {
        this.setState({selected_source: e.target.value});
    }

    handleFarmSelection = (e) => {
        this.setState({selected_farm: e.target.value});
    }

    handleFarmReturnSelection = (e) => {
        this.setState({selected_farm_return: e.target.value});
    }

    handleChangeDate = (date_type, report_type, date) => {

        if(date_type === 'start'){
            if(report_type === 'sales'){
                this.setState({ salesStartDate: date });    
            } else if(report_type === 'returns'){
                this.setState({ returnsStartDate: date });    
            }
        } else if(date_type === 'end'){
            if(report_type === 'sales'){
                this.setState({ salesEndDate: date });
            } else if(report_type === 'returns'){
                this.setState({ returnsEndDate: date });    
            }
        }
        
    }

    exportReport = (report_type, e) => {
        let startDate = report_type === 'sales' ? this.state.salesStartDate : this.state.returnsStartDate;
        let endDate = report_type === 'sales' ? this.state.salesEndDate : this.state.returnsEndDate;

        let farm_id = this.state.selected_farm;
        let farm_id_return = this.state.selected_farm_return;
        let warehouse_id = this.state.selected_source;
        let filename = `Daily Inventory Report ${startDate.format(format_date_only)}-${endDate.format(format_date_only)}.xlsx`;
        if(startDate && endDate && farm_id && farm_id_return && warehouse_id){
            this.props.isLoading(true);
            WarehouseService.getDailyInventorySpecialReport(startDate, endDate, warehouse_id, farm_id, farm_id_return)
            .then(response => {
                return response.blob()
            })
            .then((blob) => {
                this.props.isLoading(false);
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                // 3. Append to html page
                document.body.appendChild(link);
                // 4. Force download
                link.click();
                // 5. Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(error => {
                this.props.isLoading(false);
                console.log(error);
            });
        } else {
            this.props.showSnackBar("Please select All fields and proceed", "error");
        }
    }
    
    render() {
        const classes = this.props.classes;
        return (
            <div className="Home sales-stats" style={{marginTop: 32}}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={1} justify="flex-start" alignItems="center">
                                <Grid item xs={12} lg={12} style={{marginTop: 10}}>
                                    <Typography variant="button" gutterBottom display="block" style={{textAlign: "left", marginLeft: 20}}>
                                        Daily Inventory Report
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} lg={2} style={{zIndex: 5}}>
                                    <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                                        <InputLabel
                                            ref={ref => {
                                            this.InputLabelRef = ref;
                                            }}
                                            htmlFor="outlined-warehouse-simple"
                                        >
                                            Warehouse
                                        </InputLabel>
                                        <Select
                                            value={this.state.selected_source}
                                            onChange={this.handleSourceSelection}
                                            input={
                                            <OutlinedInput
                                                labelWidth={50}
                                                name="Warehouse"
                                                id="outlined-source-simple"
                                            />
                                            }
                                        >
                                            {this.state.source_names}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={2} style={{zIndex: 5}}>
                                    <FormControl variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                                        <InputLabel
                                            ref={ref => {
                                            this.InputLabelRef = ref;
                                            }}
                                            htmlFor="outlined-warehouse-simple"
                                        >
                                            Farm
                                        </InputLabel>
                                        <Select
                                            value={this.state.selected_farm}
                                            onChange={this.handleFarmSelection}
                                            input={
                                            <OutlinedInput
                                                labelWidth={50}
                                                name="Warehouse"
                                                id="outlined-Farm-simple"
                                            />
                                            }
                                        >
                                            {this.state.source_names}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={2} style={{zIndex: 5}}>
                                    <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                                        <InputLabel
                                            ref={ref => {
                                            this.InputLabelRef = ref;
                                            }}
                                            htmlFor="outlined-warehouse-simple"
                                        >
                                            Farm for Return Goods
                                        </InputLabel>
                                        <Select
                                            value={this.state.selected_farm_return}
                                            onChange={this.handleFarmReturnSelection}
                                            input={
                                            <OutlinedInput
                                                labelWidth={50}
                                                name="Warehouse"
                                                id="outlined-Farm-simple"
                                            />
                                            }
                                        >
                                            {this.state.source_names}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3} lg={2}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            inputVariant="outlined"
                                            margin="normal"
                                            label="From"
                                            value={this.state.salesStartDate}
                                            onChange={(e) => this.handleChangeDate('start', 'sales', e)}
                                            format='DD MMM YYYY'
                                            maxDate={this.state.salesEndDate}
                                            className={classes.formControl}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={3} lg={2}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            inputVariant="outlined"
                                            margin="normal"
                                            label="To"
                                            value={this.state.salesEndDate}
                                            minDate={this.state.salesStartDate}
                                            onChange={(e) => this.handleChangeDate('end', 'sales', e)}
                                            format='DD MMM YYYY'
                                            className={classes.formControl}
                                            disableFuture
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={3} lg={2}>
                                    <Button  variant="outlined" size="large" color="primary" onClick={(e) => this.exportReport('sales', e)}>Export</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(InventoryReport);